import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'modal-action-panel',
  templateUrl: 'modal-action-panel.component.html',
  styleUrls: ['modal-action-panel.component.scss'],
})
export class ModalActionPanelComponent {
  @Input() show: boolean = false;
  @Input() title: string;
  @Input() showSpinner: boolean = false;
}
